import { Link } from 'react-router-dom';
import { useTourData } from '../data/tour-data';

export function TourMachinePage() {
  const fixture = useTourData();
  const { machine } = fixture;
  return (
    <section className="r42-page r42-page--wide r42-tour-workspace-page">
      <header className="r42-page-header r42-tour-page-header">
        <div>
          <span className="r42-eyebrow">Example machine</span>
          <h1>{machine.machine_name}</h1>
          <p>{machine.description}</p>
        </div>
        <span className="r42-tour-readonly-pill"><i className="bi bi-lock" aria-hidden="true" /> Read-only example</span>
      </header>

      <section className="r42-tour-machine-hero" data-tour-target="machine-overview">
        <div className="r42-tour-machine-identity">
          <div className="r42-tour-machine-icon"><i className="bi bi-gear-wide-connected" aria-hidden="true" /></div>
          <div>
            <span className="r42-eyebrow">Asset {machine.asset_id}</span>
            <h2>{machine.machine_type}</h2>
            <p>{machine.manufacturer} · {machine.model}</p>
          </div>
        </div>
        <dl className="r42-tour-machine-facts">
          <div><dt>Facility</dt><dd>{machine.facility_name}</dd></div>
          <div><dt>Area</dt><dd>{machine.production_area}</dd></div>
          <div><dt>Location</dt><dd>{machine.location}</dd></div>
          <div><dt>Status</dt><dd><span className="r42-tour-status-dot" /> {machine.status === 'ACTIVE' ? 'Active' : machine.status}</dd></div>
        </dl>
      </section>

      <section className="r42-tour-question-card">
        <span className="r42-eyebrow">The machine question</span>
        <h2>“{fixture.story.machine_question}”</h2>
        <p>{fixture.story.operator_goal}</p>
        <Link className="btn r42-btn-primary" to="/tour/conversation">See how Route42 answers</Link>
      </section>

      <div className="r42-tour-stat-grid" aria-label="Example workspace summary">
        <Link to="/tour/documents"><strong>{fixture.evidence_sources.length}</strong><span>Evidence sources</span><small>PDF · CSV · image</small></Link>
        <Link to="/tour/conversation"><strong>{fixture.conversation.messages.length}</strong><span>Conversation messages</span><small>Grounded in evidence</small></Link>
        <Link to="/tour/investigation"><strong>{fixture.investigation.hypotheses.length}</strong><span>Active hypotheses</span><small>None claimed as root cause</small></Link>
        <Link to="/tour/memory"><strong>v{fixture.machine_memory.memory_version}</strong><span>Machine Memory</span><small>Persistent understanding</small></Link>
      </div>

      <section className="r42-tour-principle-card">
        <i className="bi bi-lightbulb" aria-hidden="true" />
        <div><span className="r42-eyebrow">What this example demonstrates</span><h2>Route42 connects evidence without inventing certainty.</h2><p>{fixture.story.aha}</p></div>
      </section>
    </section>
  );
}
